"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgRefreshClock = function SvgRefreshClock(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.449 8c0-3.314-2.69-6-6.006-6a6.008 6.008 0 0 0-5.57 3.75M2.436 8c0 3.314 2.69 6 6.007 6a6.008 6.008 0 0 0 5.461-3.5",
    stroke: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.726 10.441 1.476-2.413 2.413 1.475m11.76-3.457-1.573 2.35-2.351-1.572m-6.21-1.777L8.72 8.44h3.028",
    stroke: "#919499"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgRefreshClock);
var _default = Memo;
exports["default"] = _default;